module.exports = __webpack_public_path__ + "media/printed-materials/educators-07-college-qrq-fb99f350.jpg";